import { DOCUMENT, isPlatformBrowser } from '@angular/common';
import { inject, Inject, Injectable, PLATFORM_ID } from '@angular/core';

declare global {
  interface Window {
    dataLayer: any[];
  }
}

@Injectable({
  providedIn: 'root'
})
export class GoogleTagManagerService {
  #platformId = inject(PLATFORM_ID);
  #document = inject(DOCUMENT);

  private safePush(payload: object): void {
    //Make sure its not Server Side Rendered(SSR). If SSR, it will not work.
    if(!isPlatformBrowser(this.#platformId)) return;

    const win = this.#document.defaultView;
    if(!win) return;

    win.dataLayer = win.dataLayer || [];
    win.dataLayer.push(payload);
  }

  public addDataLayerValue(dataLayerVariable: string, value: string) {
    this.safePush({
      [dataLayerVariable]: value,
    });
  }

  public pushLogin(userId: string, userEmail: string) {
    //Push the login event
    this.safePush({
      'event': 'login',
      'user_id': userId,
      'email': userEmail
    })

    //May be redundant, but it will make sure the user_id and email are set in the dataLayer ouitside of login event
    this.safePush({
      'user_id': userId,
      'email': userEmail
    })
  }

  public pushPurchase(purchaseInfo: object) {
    //Clear out the previous purchase data
    this.safePush({ ecommerce: null });

    //Push the purchase event
    this.safePush({
      'event': 'purchase',
      'ecommerce': purchaseInfo,
    });
  }

}
